<!-- Polaris (fase 5.5): the page of the companies list, the contacts list's layout (fase 5.1): the head, the list
     with its own scroll and container (`@container/list`, columns leave by the list's room), and the kit's
     PaginationFooter (fase P, 25 a page as today). The `drawer` slot is the column beside the list (5.6). -->
<script setup>
import CompanyHeader from './CompaniesHeader/CompanyHeader.vue';
import PaginationFooter from 'dashboard/components-next/polaris/cards/PaginationFooter.vue';

defineProps({
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, default: '' },
  count: { type: Number, default: null },
  currentPage: { type: Number, default: 1 },
  totalItems: { type: Number, default: 100 },
  activeSort: { type: String, default: 'name' },
  activeOrdering: { type: String, default: '' },
  showPaginationFooter: { type: Boolean, default: true },
});

const emit = defineEmits([
  'update:currentPage',
  'update:sort',
  'search',
  'create',
]);
</script>

<template>
  <section
    class="flex h-full min-h-0 w-full bg-polaris-background text-polaris-foreground"
  >
    <div class="flex min-w-0 flex-1 flex-col">
      <CompanyHeader
        :search-value="searchValue"
        :header-title="headerTitle"
        :count="count"
        :active-sort="activeSort"
        :active-ordering="activeOrdering"
        @search="emit('search', $event)"
        @update:sort="emit('update:sort', $event)"
        @create="emit('create')"
      />
      <main class="@container/list min-h-0 flex-1 overflow-auto">
        <slot name="default" />
      </main>
      <footer
        v-if="showPaginationFooter"
        class="shrink-0 border-0 border-t border-solid border-polaris-border px-6 py-3"
      >
        <PaginationFooter
          :page="currentPage"
          :total="totalItems"
          :page-size="25"
          count-key="COMPANIES_POLARIS.PAGINATION.COUNT"
          showing-key="COMPANIES_POLARIS.PAGINATION.SHOWING"
          @update:page="page => emit('update:currentPage', page)"
        />
      </footer>
    </div>
    <slot name="drawer" />
  </section>
</template>
